import { SelectObject, FrequencySelectObject } from './types';
import { PropertyListingStatus, UserRole, UserStatus } from '../generated/graphql';

export const STAKEHOLDER_ROLE = [
  { label: 'Child', value: 'CHILD' },
  { label: 'Contractor', value: 'CONTRACTOR' },
  { label: 'Owner', value: 'OWNER' },
  { label: 'Resident', value: 'RESIDENT' },
  { label: 'Staff', value: 'STAFF' },
  { label: 'Steyn City Staff', value: 'STEYN_CITY_STAFF' },
  { label: 'Subcontractor', value: 'SUB_CONTRACTOR' },
  { label: 'Tenant', value: 'TENANT' },
];

export const COMPACT_STAKEHOLDER_ROLE = [
  { label: 'Owner', value: 'OWNER' },
  { label: 'Resident', value: 'RESIDENT' },
  { label: 'Tenant', value: 'TENANT' },
  { label: 'Visitor', value: 'VISITOR' },
];

export const PET_APPLICATION_ROLE = [
  { label: 'Owner', value: 'OWNER' },
  { label: 'Tenant', value: 'TENANT' },
];

export const SHUTTLE_SERVICE_ROLE = [
  { label: 'Owner', value: 'OWNER' },
  { label: 'Vendor Admin', value: 'VENDOR_ADMIN' },
  { label: 'Tenant', value: 'TENANT' },
];

export const CLASSIFIED_CATEGORY_STATUS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Archived', value: 'ARCHIVED' },
];

export const FOUNDATION_STATUS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Archived', value: 'ARCHIVED' },
  { label: 'Pending', value: 'PENDING' },
];

export const GUIDEDTRAIL_POI_STATUS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Archived', value: 'ARCHIVED' },
];

export const NEIGHBOURHOOD_SERVICE_STATUS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Archived', value: 'ARCHIVED' },
];

export const GUIDEDTRAIL_CATEGORY_STATUS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Archived', value: 'ARCHIVED' },
];

export const GUIDEDTRAIL_STATUS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'New', value: 'PENDING' },
  { label: 'Rejected', value: 'REJECTED' },
  { label: 'Archived', value: 'ARCHIVED' },
];

export const MULTI_SELECT_STAKEHOLDER_ROLES = [
  { label: 'Child', value: 'CHILD', isMultiSelect: true },
  { label: 'Contractor', value: 'CONTRACTOR', isMultiSelect: true },
  { label: 'Public', value: 'GUEST', isMultiSelect: true },
  { label: 'Owner', value: 'OWNER', isMultiSelect: true },
  { label: 'Resident', value: 'RESIDENT', isMultiSelect: true },
  { label: 'Staff', value: 'STAFF', isMultiSelect: true },
  { label: 'Steyn City Staff', value: 'STEYN_CITY_STAFF', isMultiSelect: true },
  { label: 'Subcontractor', value: 'SUB_CONTRACTOR', isMultiSelect: true },
  { label: 'Tenant', value: 'TENANT', isMultiSelect: true },
];

export const TITLE_TYPE = [
  { label: 'Mr', value: 'MR' },
  { label: 'Mrs', value: 'MRS' },
  { label: 'Miss', value: 'MISS' },
  { label: 'Ms', value: 'MS' },
  { label: 'Dr', value: 'DR' },
];

export const APPLICATION_TYPES = [
  { label: 'Bank Debit Order Instruction', value: 'BANK_DEBIT_ORDER_INSTRUCTION' },
  { label: 'Contractor Security Access', value: 'CONTRACTOR_SECURITY_ACCESS' },
  { label: 'Subcontractor Security Access', value: 'SUBCONTRACTOR_SECURITY_ACCESS' },
  { label: 'Crimcheck', value: 'CRIMCHECK' },
  { label: 'Shuttle Service', value: 'SHUTTLE_SERVICE' },
  { label: 'Special Access', value: 'SPECIAL_ACCESS' },
  { label: 'Gym Membership', value: 'GYM_MEMBERSHIP' },
  { label: 'Pet Registration', value: 'PET' },
  { label: 'Resident Security Access', value: 'RESIDENTS_SECURITY_ACCESS' },
  { label: 'Security Access', value: 'SECURITY_ACCESS' },
  { label: 'Tennis Membership', value: 'TENNIS_MEMBERSHIP' },
  { label: 'Vehicle Security Access', value: 'VEHICLE_SECURITY_ACCESS' },
];

export const APPLICANT_OPTIONS = [
  { label: 'Estate Staff', value: 'ESTATE_STAFF' },
  { label: 'Domestic Worker', value: 'DOMESTIC_WORKER' },
  { label: 'Gardener', value: 'GARDENER' },
  { label: 'Minor', value: 'MINOR' },
  { label: 'Other', value: 'OTHER' },
];

export const SHUTTLE_APPLICANT_OPTIONS = [
  { label: 'Domestic Worker', value: 'DOMESTIC_WORKER' },
  { label: 'Gardener', value: 'GARDENER' },
  { label: 'Facility Staff', value: 'FACILITY_STAFF' },
  { label: 'Minor', value: 'MINOR' },
];

export const SUBCONTRACTOR_APPLICANT_OPTIONS = [
  { label: 'Applicant', value: 'APPLICANT' },
  { label: 'Contractor', value: 'CONTRACTOR' },
];

export const FILTER_VALUES = [
  { label: 'Vacant Land', value: 'VACANT_LAND' },
  { label: 'Completed Property', value: 'COMPLETED_PROPERTY' },
  { label: 'City Centre', value: 'CITY_CENTRE' },
  { label: 'Apartments', value: 'APARTMENTS' },
  { label: 'Cluster', value: 'CLUSTER' },
];

export const GYM_MEMBERSHIP_TYPE_OPTIONS = [
  { label: 'Monthly', value: 'MONTHLY' },
  { label: '6 Months', value: '6MONTHS' },
];

export const GYM_PAYMENT_METHOD_1 = [
  { label: 'Debit Order', value: 'DEBIT_ORDER' },
  { label: 'Up Front', value: 'UPFRONT' },
];

export const GYM_PAYMENT_METHOD_2 = [
  { label: 'Cash', value: 'CASH' },
  { label: 'EFT', value: 'EFT' },
  { label: 'Credit Card', value: 'Credit Card' },
];

export const PET_GENDER = [
  { label: 'Male', value: 'MALE' },
  { label: 'Female', value: 'FEMALE' },
];

export const DAYSRECURING = [
  { label: 'MONDAY', value: 'MONDAY' },
  { label: 'TUESDAY', value: 'TUESDAY' },
  { label: 'WEDNESDAY', value: 'WEDNESDAY' },
  { label: 'THURSDAY', value: 'THURSDAY' },
  { label: 'FRIDAY', value: 'FRIDAY' },
  { label: 'SATURDAY', value: 'SATURDAY' },
  { label: 'SUNDAY', value: 'SUNDAY' },
]

export enum StatusValue {
  NEW = 'NEW',
  ARCHIVED = 'ARCHIVED',
  PAID = 'PAID',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  CANCELLED = 'CANCELLED',
}

export enum PostType {
  NEWS = 'NEWS',
  UPDATE = 'UPDATE',
  HAPPENING = 'HAPPENING',
  FAQ = 'FAQ',
}

export enum Recurs {
  DAILY = 'days',
  WEEKLY = 'weeks',
  MONTHLY = 'months',
  YEARLY = 'years',
}

export enum Days {
  MON = 'MONDAY',
  TUES = 'TUESDAY',
  WED = 'WEDNESDAY',
  THUR = 'THURSDAY',
  FRI = 'FRIDAY',
  SAT = 'SATURDAY',
  SUN = 'SUNDAY',
}

export enum EventType {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
  RESIDENTS = 'RESIDENTS',
}

export enum PostCategory {
  SPORTS = 'SPORTS',
}

export enum StakeholderRole {
  OWNER = 'OWNER',
  CHILD = 'CHILD',
  RESIDENT = 'RESIDENT',
  TENANT = 'TENANT',
  CONTRACTOR = 'CONTRACTOR',
  SUBCONTRACTOR = 'SUBCONTRACTOR',
  STAFF = 'STAFF',
  STEYNCITYSTAFF = 'STEYNCITYSTAFF',
}

export enum ClubCategory {
  Sports = 'SPORTS',
  Equestrian = 'EQUESTRIAN',
  Books = 'BOOKS',
}

export const EVENT_FILTER_VALUES: SelectObject[] = [
  { label: 'Public', value: EventType.PUBLIC },
  { label: 'Private', value: EventType.PRIVATE },
  { label: 'Residents', value: EventType.RESIDENTS },
];

export const RECURS_OPTIONS: FrequencySelectObject[] = [
  { label: 'Daily', value: Recurs.DAILY },
  { label: 'Weekly', value: Recurs.WEEKLY },
  { label: 'Monthly', value: Recurs.MONTHLY },
  { label: 'Yearly', value: Recurs.YEARLY },
];

export const CATEGORY_OPTIONS: SelectObject[] = [
  { label: 'Sports', value: ClubCategory.Sports },
  { label: 'Equestrian', value: ClubCategory.Equestrian },
  { label: 'Books', value: ClubCategory.Books },
];

export const PROPERTY_LISTINGS_STATUS: SelectObject[] = [
  { label: 'Archived', value: PropertyListingStatus.Archived },
  { label: 'Draft', value: PropertyListingStatus.Draft },
  { label: 'Published', value: PropertyListingStatus.Published },
];

// export const PROPERTY_LISTINGS_STATUS: SelectObject[] = [
//   { label: 'Archived', value: PropertyListingStatus.Archived },
//   { label: 'Draft', value: PropertyListingStatus.Draft },
//   { label: 'Published', value: PropertyListingStatus.Published },
// ];

export const USER_STATUS: SelectObject[] = [
  { label: 'New', value: UserStatus.New },
  { label: 'Active', value: UserStatus.Active },
  { label: 'Archived', value: UserStatus.Archived },
];

export const EMERGENCY_CATEGORIES: SelectObject[] = [
  { label: 'Medical', value: 'MEDICAL' },
  { label: 'Security', value: 'SECURITY' },
  { label: 'SOS', value: 'SOS' },
  { label: 'Hazardous', value: 'HAZARDOUS' },
  { label: 'Suspicious Activity', value: 'SUSPICIOUS_ACTIVITY' },
];

export const USER_ROLES: SelectObject[] = [
  { label: 'Admin', value: UserRole.Admin },
  { label: 'Super Admin', value: UserRole.Superadmin },
  { label: 'Club Admin', value: UserRole.ClubAdmin },
  { label: 'Content Admin', value: UserRole.ContentAdmin },
  { label: 'Event Admin', value: UserRole.EventAdmin },
  { label: 'Event Manager', value: UserRole.EventManager },
  { label: 'Sales Agent', value: UserRole.SalesAgent },
  { label: 'Security Admin', value: UserRole.SecurityAdmin },
  { label: 'Security Guard', value: UserRole.SecurityGuard },
  { label: 'Stakeholder Admin', value: UserRole.StakeholderAdmin },
];

export const SECURITY_ROLES: SelectObject[] = [
  { label: 'Security Guard', value: UserRole.SecurityGuard },
];

export const VENDOR_ROLES: SelectObject[] = [
  { label: 'Vendor Admin', value: UserRole.VendorAdmin },
  { label: 'Team Member', value: UserRole.VendorUser },
];



// WEBPACK FOOTER //
// ./src/utils/enums.ts